// ===================================================================
// !WARNING
// The function is loaded when the youtube api is loaded (async)
// ===================================================================

(function(global) { // eslint-disable-line
    var pluginName = 'grVideoYoutube';

    function grVideoYoutube(selector) {
        this.ready = false;
        this.selector = this.selector = typeof selector === 'string' ? document.querySelector(selector) : selector;
        this.playerElement = this.selector.querySelector('[data-id]');
        this.player = null;
        this.autoplay = false;
        this.videoId = null;
        this.ratio = 16/9;
        this.videoEnded = false;
        this.playerDefaults = {
            autoplay: 0,
            autohide: 1,
            modestbranding: 0,
            rel: 0,
            showinfo: 0,
            controls: 0,
            disablekb: 1,
            enablejsapi: 0,
            iv_load_policy: 3
        };
        this.init();
    }

    grVideoYoutube.prototype.init = function init() {
        if (this.selector === null) {
            throw new Error(pluginName + ': fail - something wrong with your selector');
        }

        // Set dataset configuration in global scope
        var data = this.getConfig();
        this.autoplay = JSON.parse(data.autoplay); // get access to a bool instead of a string
        this.videoId = data.id;

        // This function creates an <iframe> (and YouTube player)
        this.player = new YT.Player(this.playerElement, { // eslint-disable-line
            height: '390',
            width: '640',
            events: {
                'onReady': this.onPlayerReady.bind(this),
                'onStateChange': this.onPlayerStateChange.bind(this)
            },
            playerVars: this.playerDefaults
        });

        this.bindEvents();
    };

    grVideoYoutube.prototype.bindEvents = function bindEvents() {
        window.addEventListener('resize', this.playerRescale.bind(this));
    };

    // The API will call this function when the video player is ready.
    grVideoYoutube.prototype.onPlayerReady = function onPlayerReady(event) {
        // Load the video... (autoplay)
        var player = event.target;
        player.loadVideoById(this.videoId);
        player.mute();
        this.playerRescale();

        // ... but pause the video if autoplay is set to false
        if (!this.autoplay) {
            console.warn('Video is paused, autoplay:', this.autoplay);
            this.pause();
        }

        // Flag the plugin as ready
        
        this.ready = true;

        // Add a custom event to player ready

        this.selector.dispatchEvent(new CustomEvent('grVideoYoutubeOnPlayerReady', {
            detail: this
        }));


    };

    grVideoYoutube.prototype.onPlayerStateChange = function onPlayerStateChange(event) {
        if (event.data === 1) {
            // Video is playing
            // console.log('playing');
            this.selector.classList.remove('is-paused');
            this.selector.classList.add('is-playing');
        } else if (event.data === 2) {
            // Video is paused
            // console.log('paused');
            this.selector.classList.remove('is-playing');
            this.selector.classList.add('is-paused');
        } else if (event.data === 0) {
            // Video has ended
            // console.log('ended')
            // loop without reloading the video
            this.videoEnded = true;

            this.selector.dispatchEvent(new CustomEvent('grVideoYoutubeOnVideoEnded', {
                detail: this
            }));

            if(this.autoplay) {
                this.play();
            }
        }
    };

    // Resize the player responsivly
    grVideoYoutube.prototype.playerRescale = function playerRescale() {
        var width = window.innerWidth;
        var height = window.innerHeight;
        var screenRatio = width / height;

        if (screenRatio > this.ratio) {
            this.player.setSize(width, width / 16 * 9);
        } else {
            this.player.setSize(height / 9 * 16, height);
        }
    };

    grVideoYoutube.prototype.getConfig = function getConfig() {
        return this.playerElement.dataset;
    };

    grVideoYoutube.prototype.play = function play() {
        this.player.playVideo();
    };

    grVideoYoutube.prototype.pause = function pause() {
        this.player.pauseVideo();
    };

    grVideoYoutube.prototype.stop = function stop() {
        this.player.stopVideo();
    };

    grVideoYoutube.prototype.replay = function replay() {
        this.player.seekTo(0);
        this.play();
    };

    // Export to CommonJS
    if (typeof module !== 'undefined' && module.exports) module.exports = grVideoYoutube;
    // Export to Browser
    else global[pluginName] = grVideoYoutube; // eslint-disable-line
}( window.groots ));
